<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    window.addEventListener('unload', this.saveState);
  },
  methods: {
    saveState(){
      sessionStorage.setItem('state', JSON.stringify(this.$store.state.user));
    } 
  }
}
</script>

<style>
html {
  height: 100%;
  font-size: 1em;
}
body {
  padding: 0;
  margin: 0;
  height: 100%;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue